//import에 대한 설명은 src/Admin/Login/AdminLogin.js 파일에 자세하게 설명해났습니다. 참고하세요.
import React, {useEffect, useState, useRef} from 'react';
//AdminHeader에 대한 설명은 src/Admin/Main.js 참고
import AdminHeader from '../Section/AdminHeader';
//이거는 tabulator라는 게시판을 쉽게 만들기 위한 패키지이고
//https://tabulator.info/ <-이게 공식 홈페이지입니다.
//저는 게시판을 만들때 Tabulator를 많이사용합니다.
//설치는 npm install react-tabulator 로 설치했고요 :)
import { ReactTabulator } from 'react-tabulator';
import * as H from '../../Styles/StyleComponentHan';
//아래 함수들에 대한 자세한 설명은 Axios.js 파일을 참고하세요
import {
  get_guarantee,
  get_guarantee_management_search,
  delete_guarantee,
} from "../../Axios";
import detail_icon from '../../Images/Etc/detail_icon.png';

export function GuaranteeManagement() {  

  // useState는 React에서 제공하는 hook인데 자세한 설명은 /src/Admin/Login/AdminLogin.js파일에 설명을 해났음
  // 참고로 useState([])이렇게 하면 처음 기본값은 []빈배열이라는 것이고 초기값도 저안에 값을 어떻게 하냐에 따라 다릅니다.
  const [guaranteeData, setGuaranteeData] = useState([]); //백엔드에서 가져온 보증기간 데이터를 담기위한 useState

  //검색 데이터
  const [guaranteeSearch1, setGuaranteeSearch1] = useState('');
  const [guaranteeSearch2, setGuaranteeSearch2] = useState('');

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      form_check();
    }
  };

  // useRef는 React에서 제공하는 hook인데 밑에 HTML을 참고하기 위해 useRef를 사용합니다.
  // tabulatorRef이거는 아래 <ReactTabulator> 이거를  참고하기 위해 사용했으며
  // <ReactTabulator> 가면 tabulatorRef를 사용한것을 볼 수 있습니다.
  const tabulatorRef = useRef();

  //이 함수는 보증서 목록을 불러오는 공통 함수입니다.
  //처음 진입했을 때도 사용하고 검색 이후 목록을 다시 그릴 때도 재사용합니다.
  //검색을 했는데 데이터가 없는 경우에만 alert를 띄우기 위해 shouldAlertWhenEmpty를 따로 받습니다.
  const load_guarantee_data = (
    search_value_1 = '',
    search_value_2 = '',
    shouldAlertWhenEmpty = false,
  ) =>{
    //검색값이 둘 다 비어있으면 전체 목록 API를 호출하고
    //하나라도 입력되어 있으면 검색 API를 호출합니다.
    const request_function =
      search_value_1 === '' && search_value_2 === ''
        ? get_guarantee()
        : get_guarantee_management_search(search_value_1, search_value_2);

    request_function.then((result_data)=>{
      //백엔드 응답이 없을 때는 화면 상태를 건드리지 않고 사용자에게만 알립니다.
      if(result_data === undefined){
        alert('보증서 데이터를 불러오지 못했습니다. 관리자한테 확인해주세요.');
        return;
      }

      //검색 시도였고 결과가 비어있을 때만 안내 문구를 노출합니다.
      if(shouldAlertWhenEmpty === true && result_data.length === 0){
        alert('검색된 데이터가 없습니다. 시공점에 확인해주세요.');
      }

      //최종적으로 현재 화면에서 사용하는 목록 상태를 최신 데이터로 교체합니다.
      setGuaranteeData(result_data);
    })
  }

  // useEffect는 React에서 제공하는 hook인데 자세한 설명은 /src/Admin/Section/AdminHeader.js파일에 설명을 해났음
  useEffect(() => {
    //처음 페이지 진입 시 전체 보증서 목록을 불러옵니다.
    load_guarantee_data();
  },[]);


  //컨트롤 함수
  const form_check = () =>{
    //검색 버튼과 엔터 입력은 같은 검색 로직을 타게 통일합니다.
    load_guarantee_data(
      guaranteeSearch1,
      guaranteeSearch2,
      true,
    );
  }

  //이 함수는 삭제 버튼을 눌렀을 때 실행되는 함수입니다.
  //여러 개를 동시에 삭제할 수 있도록 선택된 행들을 전부 수집해서 API로 넘깁니다.
  const check_guarantee_delete = () =>{
    //테이블이 아직 생성되기 전에 버튼이 눌리는 예외 상황을 먼저 막습니다.
    if(tabulatorRef.current === undefined){
      alert('보증서 목록이 아직 준비되지 않았습니다.');
      return;
    }

    //선택된 보증서 데이터를 한 번만 읽어서 이후 로직에서 재사용합니다.
    const selected_guarantee_data = tabulatorRef.current.getSelectedData();

    if(selected_guarantee_data.length === 0){
      alert('삭제할 데이터를 선택해주세요.');
      return;
    }

    //실수 삭제를 막기 위해 최종 확인을 한 번 더 받습니다.
    if(window.confirm('선택한 보증서를 삭제하시겠습니까?') === false){
      return;
    }

    //백엔드로는 보증서 고유 ID 배열만 넘기면 되므로 별도 배열을 만듭니다.
    let temp_delete_array = [];

    selected_guarantee_data.forEach((element)=>{
      temp_delete_array.push(element.guarantee_ID);
    })

    delete_guarantee(temp_delete_array).then((result)=>{
      //undefined 이거나 실제 삭제된 행 수가 0이면 실패로 판단합니다.
      if(result === undefined || result.affectedRows === 0){
        alert('삭제가 되지 않았습니다. 관리자한테 확인해주세요.');
      }else{
        alert('삭제가 완료 되었습니다.');

        //전체 새로고침은 올드한 방식이라 현재 검색 조건만 유지한 채 목록만 다시 불러옵니다.
        load_guarantee_data(
          guaranteeSearch1,
          guaranteeSearch2,
          false,
        );
      }
    })
  }

  // 테이블에 사용하는 아이콘
  const detailIcon = function(){
    return `
<img 
  src=${detail_icon} 
  alt="디테일 이미지"
  style="width:15px;heihgt:15px"
/>`
  };
  
  const set_film_colums = (cell)=>{
    let temp_construction_product_print = '';

    if(cell.getRow().getData().guarantee_vehicle_division === 1){
      if(cell.getRow().getData().guarantee_windshield_use_optimum_film_type_ID !== 0){
        temp_construction_product_print = temp_construction_product_print + '전면('+cell.getRow().getData().guarantee_windshield_use_optimum_film_type_name+'), ';
      }
      if(cell.getRow().getData().guarantee_side_glass_1_use_optimum_film_type_ID !== 0){
        temp_construction_product_print = temp_construction_product_print + '측면1('+cell.getRow().getData().guarantee_side_glass_1_use_optimum_film_type_name+'), ';
      }
      if(cell.getRow().getData().guarantee_side_glass_2_use_optimum_film_type_ID !== 0){
        temp_construction_product_print = temp_construction_product_print + '측면2('+cell.getRow().getData().guarantee_side_glass_2_use_optimum_film_type_name+'), ';
      }
      if(cell.getRow().getData().guarantee_side_glass_3_use_optimum_film_type_ID !== 0){
        temp_construction_product_print = temp_construction_product_print + '측면3('+cell.getRow().getData().guarantee_side_glass_3_use_optimum_film_type_name+'), ';
      }
      if(cell.getRow().getData().guarantee_rear_glass_use_optimum_film_type_ID !== 0){
        temp_construction_product_print = temp_construction_product_print + '후면('+cell.getRow().getData().guarantee_rear_glass_use_optimum_film_type_name+'), ';
      }
      if(cell.getRow().getData().guarantee_roof_glass_use_optimum_film_type_ID !== 0){
        temp_construction_product_print = temp_construction_product_print + '루프('+cell.getRow().getData().guarantee_roof_glass_use_optimum_film_type_name+'), ';
      }     
    }else{ 
      temp_construction_product_print = cell.getRow().getData().guiarantee_construction_film
    }
    return temp_construction_product_print;
  }
  
  return (
    <H.admin_MainWrap> {/* 전체박스 */}
      <AdminHeader/> {/* 헤더 */}
      <H.admin_rightWrap> {/* 우측 전체박스*/}
        <H.admin_rightTitBox>{/* 우측 박스 */}
          <H.admin_rightTitInner>{/* 우측 이너이너 */}
            <p>보증서 관리</p>
            <div>
              <H.admin_deleteBtn
                //삭제 버튼을 누르면 선택된 보증서들을 삭제합니다.
                onClick={()=>{check_guarantee_delete();}}>삭제
              </H.admin_deleteBtn>
            </div>
          </H.admin_rightTitInner>
        </H.admin_rightTitBox>

        <H.admin_topSearch>
          <div className="admin_topSearchInner">
            <div className="admin_topSearchLabel">
              {/* htmlFor에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고*/}
              <label htmlFor='guarantee_search_1'>1차 검색명</label>
              <input 
                type='text' 
                id = 'guarantee_search_1' 
                maxLength={20} 
                //onChange에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고
                onChange={(event_data)=>{
                  setGuaranteeSearch1(event_data.target.value);
                }} 
                onKeyDown={handleKeyDown}
                placeholder = "1차 검색명을 입력해 주세요."
                value={guaranteeSearch1}
              />
            </div>

            <div className="admin_topSearchLabel">
              {/* htmlFor에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고*/}
              <label htmlFor='guarantee_search_2'>2차 검색명</label>
              <input 
                type='text' 
                id = 'guarantee_search_2' 
                maxLength={20} 
                //onChange에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고
                onChange={(event_data)=>{
                  setGuaranteeSearch2(event_data.target.value);
                }} 
                onKeyDown={handleKeyDown}
                placeholder = "2차 검색명을 입력해 주세요."
                value={guaranteeSearch2}
              />
            </div>
          
            <button
              //onClick event에 대한 내용은 src/Admin/Login.js 참고
              onClick={()=>{form_check(); }}>
              {/* 보증서 파라미터가 있는지 없는지에 따라 등록인지 수정인지 판단 */}
              검색
            </button>
          </div>
        </H.admin_topSearch>
          
        <H.admin_rightInfoBox>{/* 우측 아래 */}
          <H.admin_rightInfoInner>
            <H.listInfoText>
              <p className="listInfoTextBold">사용 방법 안내</p>
              <p>1. 삭제할 보증서는 좌측 체크박스로 선택한 뒤 삭제 버튼을 눌러주세요.</p>
              <p>2. 상세보기 아이콘을 누르면 해당 보증서의 상세 화면으로 이동합니다.</p>
            </H.listInfoText>
            {
            guaranteeData.length !== 0 ? 
            <ReactTabulator
              onRef={(r) => (tabulatorRef.current = r.current)}
              data={guaranteeData}
              //밑에 있는 colums는 tabulator에서 제공하는 형식에 맞춰서 컬럼들을 정의하는 겁니다.
              //자세한 내용은 https://tabulator.info/ 공식홈페이지 참고하시면 됩니다.
              columns={[
                {formatter:"rowSelection", titleFormatter:"rowSelection", headerSort:false, hozAlign:"center",
                  cellClick:function(e, cell){
                    //체크박스 셀을 클릭했을 때 선택 상태를 토글합니다.
                    cell.getRow().toggleSelect();
                  }
                },
                { title: "ID", field: "guarantee_ID", headerSort:false},
                { title: "상세보기", formatter:detailIcon, hozAlign:"center", headerSort:false,
                cellClick:function(e, cell){
                  window.location.href = `/GuaranteeManagementDetail?guarantee_ID=${cell.getRow().getData().guarantee_ID}`;
                }},
                { title: "시공점명", field: "construction_point_name", headerSort:false},
                { title: "시공 일자", field: "guarantee_construction_date", headerSort:false},
                { title: "보증서 구분 숫자", field: "guarantee_vehicle_division", visible:false},
                { title: "보증서 구분", field: "guarantee_vehicle_division_name", headerSort:false},
                { title: "차종", field: "guarantee_car_type", headerSort:false},
                { title: "차량번호", field: "guarantee_car_number", headerSort:false},
                { title: "고객명", field: "guarantee_customer_name", headerSort:false},
                { title: "고객전화번호", field: "guarantee_customer_phone_number", headerSort:false},
                { title: "시공필름", headerSort:false, formatter:set_film_colums},
                { title: "시공위치", field: "guiarantee_construction_location", headerSort:false},
                { title: "시공필름(건축용)", field: "guiarantee_construction_film", visible:false},
                { title: "후기등록", field: "guarantee_review", headerSort:false},
                { title: "메모", field: "guarantee_memo", headerSort:false},
                { title: "등록 일자", field: "guarantee_registe", headerSort:false},
                { title: "수정 일자", field: "guarantee_modified", headerSort:false},     
              ]}
              options={{ 
                paginationSize:30,
                pagination:'local',
                paginationButtonCount:5, // 밑에 표시될 페이지 갯수
                selectableRows:true,
              }}
              layout={"fitData"}
              />
            : 
            <div>
              <p>데이터가 없습니다.</p>  
            </div>
            }
          </H.admin_rightInfoInner>
        </H.admin_rightInfoBox>

      </H.admin_rightWrap>
    </H.admin_MainWrap>
  );
}

//export default에 대한 내용은 src/Admin/Section/AdminHeader.js에 설명해났습니다.
export default GuaranteeManagement;
